import { 
  FETCH_ALL_DRIVERS_STATUS,
  FETCH_ALL_DRIVERSTATUS_SUCCESS,
  FETCH_ALL_DRIVERSTATUS_FAILED,
  } from "../store/types";
  
  export const INITIAL_STATE = {
    driverstatus:null,
    loading: false,
    error:{
      flag:false,
      msg: null
    }
  }
  
  export const driverstatusreducer =  (state = INITIAL_STATE, action) => {
    switch (action.type) {
      case FETCH_ALL_DRIVERS_STATUS:
        return {
          ...state,
          loading:true
        };
      case FETCH_ALL_DRIVERSTATUS_SUCCESS:
        return {
          ...state,
          driverstatus:action.payload,
          loading:false
        };
      case FETCH_ALL_DRIVERSTATUS_FAILED:
        return {
          ...state,
          driverstatus:null,
          loading:false,
          error:{
            flag:true,
            msg:action.payload
          }
        };
      default:
        return state;
    }
  };